/** Client-side id for custom (DB) apps — avoids colliding with built-in keys like `leads`. */
export const CUSTOM_APP_PREFIX = "ca_";

export function isCustomAppId(id) {
  return typeof id === "string" && id.startsWith(CUSTOM_APP_PREFIX);
}

export function toClientAppId(dbId) {
  if (!dbId) return null;
  return `${CUSTOM_APP_PREFIX}${dbId}`;
}

export function toDbAppId(clientId) {
  if (!isCustomAppId(clientId)) return null;
  return clientId.slice(CUSTOM_APP_PREFIX.length);
}
